import React from 'react';
import { styled } from 'baseui';
import { useStyletron } from 'baseui';
import { LabelXSmall } from 'baseui/typography';
import { FRAME_WIDTH, getColumnHeaderBreakpointPointerHeight, getColumnHeaderBreakpointPointerMarginTop, getColumnHeaderHeight, getColumnHeaderPaddingVertical, ROW_HEADER_WIDTH } from './constants';
import type { ScrollGutterSizeT } from './types';
const BREAKPOINT_SIZE = 10;
type PropsT = {
  totalFrames: number;
  containerStripRef: React.RefObject<HTMLDivElement>;
  scrollGutterSize: ScrollGutterSizeT;
};
const Container = styled<'div', {
  $scrollGutterSize: ScrollGutterSizeT;
}>('div', ({
  $scrollGutterSize
}) => ({
  position: 'absolute',
  overflow: 'hidden',
  top: 0,
  left: `${ROW_HEADER_WIDTH}px`,
  right: `${$scrollGutterSize.right}px`
}));
const ContainerStrip = styled('div', {
  display: 'flex'
});
const HeaderCell = styled('div', ({
  $theme
}) => ({
  width: `${FRAME_WIDTH}px`,
  height: getColumnHeaderHeight($theme),
  padding: `${getColumnHeaderPaddingVertical($theme)} 0`,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderBottom: `1px solid ${$theme.colors.borderOpaque}`
}));
const EllipseContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: `${$theme.typography.LabelSmall.lineHeight}`
}));
const Ellipse = styled('div', ({
  $theme
}) => ({
  width: $theme.sizing.scale200,
  height: $theme.sizing.scale200,
  borderRadius: '50%',
  backgroundColor: $theme.colors.contentInverseTertiary
}));
const BreakpointPointer = styled('div', ({
  $theme
}) => ({
  width: $theme.sizing.scale0,
  height: getColumnHeaderBreakpointPointerHeight($theme),
  backgroundColor: $theme.colors.contentInverseTertiary,
  marginTop: getColumnHeaderBreakpointPointerMarginTop($theme)
}));
const FrameNumberLabel = styled(LabelXSmall, {
  userSelect: 'none'
});

/* eslint-disable react-hooks/rules-of-hooks -- FIXME: Update the component name to follow React conventions */
function _ColumnHeaders({
  totalFrames,
  containerStripRef,
  scrollGutterSize
}: PropsT) {
  const [, theme] = useStyletron();
  return <Container $scrollGutterSize={scrollGutterSize}>
      <ContainerStrip ref={containerStripRef}>
        {Array.from({
        length: totalFrames
      }).map((_, index) => {
        const isBreakpoint = index === 0 || (index + 1) % BREAKPOINT_SIZE === 0 || index === totalFrames - 1;
        const frameNumber = index + 1;
        if (isBreakpoint) {
          return <HeaderCell key={index}>
                <FrameNumberLabel color={theme.colors.contentInverseTertiary}>
                  {frameNumber}
                </FrameNumberLabel>

                <BreakpointPointer />
              </HeaderCell>;
        }
        return <HeaderCell key={index}>
              <EllipseContainer>
                <Ellipse />
              </EllipseContainer>
            </HeaderCell>;
      })}
      </ContainerStrip>
    </Container>;
}
/* eslint-enable react-hooks/rules-of-hooks */

export const ColumnHeaders = React.memo(_ColumnHeaders);